import { useEffect, useRef } from 'react';

/**
 * Call `fn` every `ms` while `enabled` and the tab is visible — the
 * conversations' polling refresh (018 research E24). A hidden tab skips its
 * ticks rather than catching up.
 */
export function useInterval(fn: () => void, ms: number, enabled = true): void {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => {
      if (document.visibilityState === 'visible') fnRef.current();
    }, ms);
    return () => clearInterval(id);
  }, [ms, enabled]);
}
